import { useEffect, useState } from 'react';

export default function AddToHomeScreen() {
  const [show, setShow] = useState(false);
  const [platform, setPlatform] = useState('ios');
  const [deferredPrompt, setDeferredPrompt] = useState(null);

  useEffect(() => {
    const handler = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
    };
    window.addEventListener('beforeinstallprompt', handler);
    return () => window.removeEventListener('beforeinstallprompt', handler);
  }, []);

  const handleOpen = () => {
    const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);
    setPlatform(isIOS ? 'ios' : 'android');

    if (!isIOS && deferredPrompt) {
      deferredPrompt.prompt();
      deferredPrompt.userChoice.then(() => setDeferredPrompt(null));
    } else {
      setShow(true);
    }
  };

  const iosSteps = [
    <span key={0}>Tap the <strong>Share</strong> button ⎋ at the bottom of Safari</span>,
    <span key={1}>Scroll down and tap <strong>"Add to Home Screen"</strong></span>,
    <span key={2}>Tap <strong>"Add"</strong> in the top-right corner</span>,
  ];

  return (
    <>
      <button
        onClick={handleOpen}
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 8,
          width: '100%',
          padding: '10px 12px',
          background: '#738f52',
          color: '#fff',
          border: 'none',
          borderRadius: 8,
          fontSize: 15,
          fontWeight: 500,
          cursor: 'pointer',
          touchAction: 'manipulation',
          WebkitTapHighlightColor: 'transparent',
        }}
      >
        <span style={{ fontSize: 18, lineHeight: 1 }}>⊕</span>
        Add to Home Screen
      </button>

      {show && (
        <div
          onClick={() => setShow(false)}
          style={{
            position: 'fixed',
            inset: 0,
            background: 'rgba(0,0,0,0.5)',
            display: 'flex',
            alignItems: 'flex-end',
            justifyContent: 'center',
            zIndex: 99999,
          }}
        >
          <div
            onClick={e => e.stopPropagation()}
            style={{
              background: '#fff',
              borderRadius: '16px 16px 0 0',
              padding: '24px 20px 40px',
              width: '100%',
              maxWidth: 480,
            }}
          >
            {/* drag handle */}
            <div style={{ width: 40, height: 4, background: '#e5e7eb', borderRadius: 2, margin: '0 auto 20px' }} />

            {/* App header row */}
            <div style={{ display: 'flex', alignItems: 'center', marginBottom: 20, paddingBottom: 16, borderBottom: '1px solid #f3f4f6' }}>
              <img
                src="/logo192.png"
                alt="App icon"
                style={{ width: 48, height: 48, borderRadius: 12, marginRight: 12 }}
              />
              <div>
                <div style={{ fontWeight: 500, fontSize: 15 }}>Auto Glass Shop</div>
                <div style={{ fontSize: 12, color: '#9ca3af' }}>autoglassshop.com.au</div>
              </div>
              <button
                onClick={() => setShow(false)}
                style={{ marginLeft: 'auto', background: 'none', border: 'none', fontSize: 24, cursor: 'pointer', color: '#9ca3af', lineHeight: 1 }}
              >
                ×
              </button>
            </div>

            {platform === 'ios' ? (
              <div>
                {iosSteps.map((text, i) => (
                  <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 16 }}>
                    <div style={{
                      width: 26, height: 26, borderRadius: '50%',
                      background: '#f0fdf4', color: '#15803d',
                      fontSize: 12, fontWeight: 600,
                      display: 'flex', alignItems: 'center', justifyContent: 'center',
                      flexShrink: 0,
                    }}>
                      {i + 1}
                    </div>
                    <div style={{ fontSize: 14, lineHeight: 1.6, paddingTop: 3 }}>{text}</div>
                  </div>
                ))}
              </div>
            ) : (
              <div style={{ fontSize: 14, color: '#6b7280', textAlign: 'center', padding: '20px 0' }}>
                Tap <strong>Install</strong> in the prompt to add to your home screen.
              </div>
            )}

            <div style={{ background: '#f0fdf4', borderRadius: 8, padding: '10px 14px', fontSize: 13, color: '#15803d', marginTop: 8 }}>
              The app icon will appear on your home screen instantly.
            </div>
          </div>
        </div>
      )}
    </>
  );
}
